import {ApiErrorResponse, ApiValidationErrorResponse, ErrorResponse} from "@/model/IResponse.ts";
import {t} from "i18next";

export const DEFAULT_ERROR_TITLES = {
  NETWORK: t('Error.Network'),
  UNAUTHORIZED: t('Error.Unauthorized'),
  FORBIDDEN: t('Error.Forbidden'),
  CONFLICT: t('Error.Conflict'),
  NOT_FOUND: t('Not found'),
  GENERIC: t('Error')
};

export const DEFAULT_ERROR_MESSAGES = {
  NETWORK: t('Error.Message.Network'),
  UNAUTHORIZED: t('Error.Message.Unauthorized'),
  FORBIDDEN: t('Error.Message.Forbidden'),
  CONFLICT: t('Error.Message.Conflict'),
  NOT_FOUND: t('Error.Message.NotFound'),
  GENERIC: t('Error.Message.Generic')
};

export interface IErrorData {
  title: string;
  errorMessage: string;
  buttonLabel: string;
  statusCode?: number;
  correlationId?: string;
  data?: any;
}

let errorData: IErrorData | null = null;
export const setError = (error: IErrorData) => errorData = error;
export const getError = (): IErrorData => errorData;

export const redirectToErrorPage = (error: IErrorData) => {
  window.history.pushState({ errorData: error }, '', '/error/redirect');
  const popStateEvent = new PopStateEvent('popstate', { state: { errorData: error } });
  window.dispatchEvent(popStateEvent);
}

export function getValidationErrorData(errorMessage: string){
  const errorData: IErrorData = {
    title: t('Generic.Error'),
    errorMessage: t(errorMessage),
    buttonLabel: t('Generic.Back'),
  };

  return errorData;
}

export async function handleFetchUnexpectedError(error: ErrorResponse) {
  return BuildFetchErrorData(error.status ?? undefined, '');
}

export async function handleFetchErrorResponse(
  response: Response,
  textError?: any
){
  const errors = await getFetchErrorMessages(response, textError);
  const errorMsg = (errors && errors.length > 0) ? errors.join(';') : '';
  const statusCode = response?.status ?? undefined;
  const correlationId = response.headers.get('X-Correlation-Id');

  return BuildFetchErrorData(statusCode, errorMsg, correlationId);
}

async function getFetchErrorMessages(apiResponse: Response, textError?: string) {
  let formattedErrors: string[] = [];
  try {
    const r = await apiResponse.json();
    if (r.message) {
      formattedErrors.push(r.message);
    } else if (r.errors && Array.isArray(r.errors)) {
      const response = r as ApiErrorResponse;
      if (response.errors.length > 0) {
        response.errors.forEach((e: string) => {
          formattedErrors.push(e);
        });
      }
    } else if (r.description) {
      formattedErrors.push(r.description);
    }
    else {
      const response = r as ApiValidationErrorResponse;
      if (response.errors) {
        Object.keys(response.errors).forEach((key) => {
          const errors = response.errors[key];
          errors.forEach((e: string) => {
            formattedErrors.push(e);
          });
        });
      }
    }
  } catch (_) {
    try{
      const apiResponseText = await apiResponse.text();
      formattedErrors.push(apiResponseText);
    }
    catch(_){
      if(textError){
        try{
          const obj = JSON.parse(textError);
          if (obj?.description) {
            const descError = JSON.parse(textError).description;
            formattedErrors.push(descError);
          }
        }
        catch(_){
          formattedErrors = [];
        }
      }
      else{
        formattedErrors = [];
      }
    }
  }
  return formattedErrors;
}

export function getErrorByStatusCode(statusCode: number){
  return BuildFetchErrorData(statusCode);
}

function BuildFetchErrorData(statusCode?: number, errorMsg: string = '', correlationId?: string){
  let title: string;
  let message: string;

  switch (statusCode) {
    case 0:
      title = DEFAULT_ERROR_TITLES.NETWORK
      message = DEFAULT_ERROR_MESSAGES.NETWORK;
      break;
    case 401:
      title = DEFAULT_ERROR_TITLES.UNAUTHORIZED;
      message = errorMsg || DEFAULT_ERROR_MESSAGES.UNAUTHORIZED;
      break;
    case 403:
      title = DEFAULT_ERROR_TITLES.FORBIDDEN;
      message = errorMsg || DEFAULT_ERROR_MESSAGES.FORBIDDEN;
      break;
    case 404:
      title = DEFAULT_ERROR_TITLES.NOT_FOUND;
      message = errorMsg || DEFAULT_ERROR_MESSAGES.NOT_FOUND;
      break;
    case 409:
      title = DEFAULT_ERROR_TITLES.CONFLICT;
      message = errorMsg || DEFAULT_ERROR_MESSAGES.CONFLICT;
      break;
    case 500:
      title = DEFAULT_ERROR_TITLES.GENERIC;
      message = DEFAULT_ERROR_MESSAGES.GENERIC;
      break;
    default:
      title = DEFAULT_ERROR_TITLES.GENERIC;
      message = errorMsg || DEFAULT_ERROR_MESSAGES.GENERIC;
      break;
  }

  const errorData: IErrorData = {
    title: title,
    errorMessage: message,
    buttonLabel: 'Back',
    statusCode: statusCode,
    correlationId: correlationId
  };

  return errorData;
}







